import React from 'react';
import { Dropdown, Label, Icon, Message } from 'semantic-ui-react';

/**
 * Voice Actor Selection Component
 * Displays dropdown for selecting active Voice Actor for testing
 */
const VoiceActorSelector = ({
  voiceActors,
  selectedVoiceActor,
  onVoiceActorChange,
  isLoading = false,
  useRealData = false,
  disabled = false
}) => {
  const voiceActorOptions = Object.entries(voiceActors || {}).map(([id, actor]) => ({
    key: id,
    value: id,
    text: `${actor.name} (${actor.experienceLevel || 'N/A'})${actor.isRealUser ? ' [Real]' : ' [Mock]'}`,
    icon: 'microphone'
  }));

  return (
    <div style={{ flex: 1, marginRight: '10px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
        <label style={{ fontWeight: 'bold', marginRight: '10px' }}>
          <Icon name="microphone" />
          Voice Actor
        </label>
        {useRealData && (
          <Label size="mini" color="green">
            <Icon name="database" />
            Real Data
          </Label>
        )}
      </div>

      <Dropdown
        placeholder={isLoading ? "Loading voice actors..." : "Select voice actor..."}
        fluid
        selection
        loading={isLoading}
        disabled={disabled || isLoading}
        value={selectedVoiceActor || ''}
        options={voiceActorOptions}
        onChange={(e, { value }) => onVoiceActorChange(value)}
        noResultsMessage={
          Object.keys(voiceActors || {}).length === 0
            ? (useRealData ? "No real voice actors found." : "No voice actors available.")
            : "No matching voice actors found"
        }
      />

      {selectedVoiceActor && voiceActors[selectedVoiceActor] && (
        <div style={{
          marginTop: '8px',
          padding: '8px',
          backgroundColor: voiceActors[selectedVoiceActor].isRealUser ? '#e8f5e8' : '#f8f9fa',
          borderRadius: '4px',
          border: voiceActors[selectedVoiceActor].isRealUser ? '1px solid #c3e6c3' : '1px solid #dee2e6',
          fontSize: '0.85em'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
            <strong>{voiceActors[selectedVoiceActor].name}</strong>
            {voiceActors[selectedVoiceActor].isRealUser && (
              <Label size="mini" color="green" style={{ marginLeft: '8px' }}>
                <Icon name="database" />
                Real User
              </Label>
            )}
          </div>
          <div>
            <strong>Rate:</strong> ${voiceActors[selectedVoiceActor].baseRate || 'N/A'}/hr |
            <strong> Experience:</strong> {voiceActors[selectedVoiceActor].experienceLevel || 'N/A'} |
            <strong> Projects:</strong> {voiceActors[selectedVoiceActor].completedProjects || 0}
          </div>
          {voiceActors[selectedVoiceActor].specialties && voiceActors[selectedVoiceActor].specialties.length > 0 && (
            <div>
              <strong>Specialties:</strong> {voiceActors[selectedVoiceActor].specialties.join(', ')}
            </div>
          )}
        </div>
      )}

      {Object.keys(voiceActors || {}).length === 0 && !isLoading && (
        <Message warning size="small" style={{ marginTop: '8px' }}>
          <Message.Header>No Voice Actors Available</Message.Header>
          <p>
            {useRealData
              ? "No real voice actors could be loaded. Try switching to Mock Data mode."
              : "No mock voice actors are available."
            }
          </p>
        </Message>
      )}

      <div style={{ marginTop: '8px', fontSize: '0.8em', color: '#666' }}>
        <Icon name="info circle" />
        {Object.keys(voiceActors || {}).length} voice actor{Object.keys(voiceActors || {}).length !== 1 ? 's' : ''} available
      </div>
    </div>
  );
};

export default VoiceActorSelector;
